import { render, staticRenderFns } from "./tasksidebar.vue?vue&type=template&id=d9e42bf8"
import script from "./tasksidebar.vue?vue&type=script&lang=js"
export * from "./tasksidebar.vue?vue&type=script&lang=js"
import style0 from "./tasksidebar.vue?vue&type=style&index=0&id=d9e42bf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports